"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDocMulti = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
require("../../../3rd_party_libraries/fuelux/wizard.js");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
const CategoryChooser_1 = require("../../../TdWebtoolkitControls/controls/CategoryChooser/CategoryChooser");
require("../../../TdWebtoolkitControls/controls/Mail/Mail");
require("../../../TdWebtoolkitControls/controls/Upload/Templates");
require("../../../TdWebtoolkitControls/controls/Upload/Upload");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const $ = require("jquery");
const m = require("../SynView");
require("./newDocMulti.tmpl.less");
let _ = require("underscore");
class newDocMulti extends m.SynView {
    //#endregion MEMBER letIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
        this.m_mappingValueRegex = /((\{)(file\.((att(ributes|archive|compressed|device|directory|encrypted|hidden|normal|notcontentindexed|offline|readonly|reparsepoint|parsefile|system|temporary|virtual))|(size)|((create|lastchange|lastaccess)date)|(name(no)?(path)?(ext)?(short)?)))(\}))/g;
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.m_wizardStep = 0;
        this.m_changedFields = [];
        this.m_ignoreFields = [];
    }
    getParametersFromUrl() {
        super.getParametersFromUrl();
        this.m_parentId = decodeURIComponent($.address.parameter("parentId"));
        this.m_relId = Number($.address.parameter("relId")) || undefined;
        if ($.address.parameter("typeid"))
            Cookies.set("lastCat_newWithTemplate", $.address.parameter("typeid"), { expires: 356 });
    }
    forceRefresh(modificationInfo) { }
    getMappingStructure() {
        let mappingStructure = {
            keys: {},
            structure: {},
            hasKeys: false
        };
        if (this.m_mappingTable && this.m_mappingTable.fields) {
            for (let key in this.m_mappingTable.fields) {
                if (this.m_mappingTable.fields.hasOwnProperty(key)) {
                    let entry = this.m_mappingTable.fields[key];
                    if (!mappingStructure.structure.hasOwnProperty(entry.typeId))
                        mappingStructure.structure[entry.typeId] = {};
                    mappingStructure.structure[entry.typeId][entry.targetField] = entry.stringFormat;
                    if (!mappingStructure.keys.hasOwnProperty(entry.targetField))
                        mappingStructure.keys[entry.targetField] = true;
                }
            }
        }
        mappingStructure.hasKeys = Object.keys(mappingStructure.keys).length > 0;
        return mappingStructure;
    }
    getPlaceHolderFields(mappingStructure) {
        let placeholderFields = [];
        let categoryHierarchy = [];
        categoryHierarchy = this.buildCategoryHierarchy(this.m_typeId, categoryHierarchy);
        for (let key in mappingStructure.keys) {
            for (let idx = 0; idx < categoryHierarchy.length; idx++) {
                let catId = categoryHierarchy[idx];
                if (mappingStructure.structure[catId] && mappingStructure.structure[catId][key]) {
                    let value = mappingStructure.structure[catId][key];
                    this.m_mappingValueRegex.lastIndex = 0;
                    let substitionMatches = [];
                    let matchArr;
                    while ((matchArr = (this.m_mappingValueRegex.exec(value) || undefined)) != undefined)
                        if (matchArr.length > 3)
                            substitionMatches.push(matchArr);
                    for (let i = substitionMatches.length - 1; i >= 0; --i) {
                        let curMatch = substitionMatches[i];
                        let before = value.substring(0, curMatch.index);
                        let after = value.substring(curMatch.index + curMatch[1].length);
                        let subst = "[" + Utilities_1.synUtil.Strings.getValue("mappingext." + curMatch[3]) + "]";
                        value = before + subst + after;
                    }
                    placeholderFields.push({
                        name: key,
                        value: kendo.format("{0}: {1}", Utilities_1.synUtil.Strings.getValue("defaultvalue"), value)
                    });
                    break;
                }
            }
        }
        return placeholderFields;
    }
    updateMappedFields() {
        let that = this;
        let categoryHierarchy = [];
        that.m_ignoreFields = [];
        if (that.m_allCategories && that.m_mappingTable)
            categoryHierarchy = that.buildCategoryHierarchy(that.m_typeId, categoryHierarchy);
        let mappingStructure = that.getMappingStructure();
        if (mappingStructure.hasKeys) {
            let placeholderFields = that.getPlaceHolderFields(mappingStructure);
            that.m_ignoreFields = $.map(placeholderFields, f => f.name);
            let ppControls = that.m_$propertyPage.data("synPropertyPage").controls.controlsByFieldName;
            _.each(placeholderFields, function (field) {
                if (ppControls.hasOwnProperty(field.name)) {
                    let controlColl = ppControls[field.name];
                    let $control = that.m_$propertyPage.find("#" + controlColl.Input.id).attr("placeholder", field.value);
                    if (!controlColl.Input.getValue())
                        $control.addClass("mappedfield");
                    else
                        $control.removeClass("mappedfield");
                }
            });
        }
    }
    renderContents() {
        let that = this;
        $.when(that.getAllCategories(), that.getMappingTable("dropfilesmap")).done(function (categories, dropFilesMap) {
            that.m_allCategories = categories;
            that.m_mappingTable = dropFilesMap;
            that.m_$categoryChooser = that.m_$container.find(".CategoryChooser");
            that.m_$propertyPage = that.m_$container.find(".PropertyPage");
            that.m_$uploadContainer = that.m_$container.find(".synUploadDiv");
            that.m_$wizardContainer = that.m_$container.find(".wizardContainer");
            that.m_$wizard = that.m_$container.find(".wizard");
            that.m_$cancelButton = that.m_$wizard.find(".btn-cancel");
            if ("phone" === that.m_clientDeviceClass)
                that.m_$categoryChooser.css("width", "300px");
            that.m_$categoryChooser
                .off("initSuccess").on("initSuccess", (evt) => {
                let categorySelected = that.m_$categoryChooser.synCategoryChooser("getSelectedCategory");
                that.m_typeId = categorySelected.id.toString();
                that.m_$uploadContainer.synUpload("setCategory", categorySelected.id);
            })
                .off("categorySelected").on("categorySelected", (evt, cat) => {
                that.m_typeId = cat.id.toString();
                that.m_$uploadContainer.synUpload("setCategory", cat.id);
                if (cat.contentMode !== CategoryChooser_1.ContentAllowedMode.Yes) {
                    that.m_contentAllowed = false;
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("ERROR_1|1038"));
                    that.enableNextWizardStep(false);
                }
                else {
                    that.m_contentAllowed = true;
                    that.enableNextWizardStep(that.m_$uploadContainer.synUpload("getFileGuids").length > 0);
                }
                if (that.m_wizardStep === 2)
                    that.updatePropertyPage(that.m_typeId);
            })
                .synCategoryChooser(({
                showIcons: true,
                showTreeButton: true,
                showDependsCheckbox: false,
                parentId: that.m_parentId,
                parentRelId: that.m_relId,
                selectionCookieName: "newWithTemplate"
            }));
            let importFiles = [];
            if ($(".staticButtons .mails").data("synMail"))
                importFiles = $(".staticButtons .mails").synMail("getAttachmentsToImport");
            let fileDragAndDrop = sessionStorage.getItem("TabsFileDragAndDrop");
            if (fileDragAndDrop) {
                importFiles = JSON.parse(fileDragAndDrop);
                sessionStorage.removeItem("TabsFileDragAndDrop");
            }
            that.m_$uploadContainer
                .off("uploadComplete").on("uploadComplete", function (event) {
                that.enableNextWizardStep(that.m_$uploadContainer.synUpload("getFileGuids").length > 0 && that.m_contentAllowed);
            })
                .off("fileRemoved").on("fileRemoved", function (event) {
                that.enableNextWizardStep(that.m_$uploadContainer.synUpload("getFileGuids").length > 0 && that.m_contentAllowed);
            })
                .synUpload({
                allowMultiple: true,
                initialFiles: importFiles
            });
            that.m_$uploadContainer.find(".k-upload-button > span").prepend("<i class='fa fa-upload'></i> ");
            that.m_$uploadContainer[0].ondragover = function (e) {
                e.preventDefault();
                e.stopPropagation();
                if (e.dataTransfer && e.dataTransfer.dropEffect)
                    e.dataTransfer.dropEffect = 'copy';
            };
            that.m_$propertyPage
                .off("valuesChanged").on("valuesChanged", function (e, changedFields, changedInstance) {
                that.m_changedFields = changedFields;
                that.updateMappedFields();
            })
                .off("valuesReverted").on("valuesReverted", function () {
                that.m_changedFields = [];
                that.updateMappedFields();
            })
                .off("instanceChanged").on("instanceChanged", function () {
                that.raiseOnViewResize();
                that.updateMappedFields();
            })
                .synPropertyPage({
                layout: "desktop" === that.m_clientDeviceClass ? "absolute" : "table"
            });
            that.m_$wizard.find(".step-upload-text").text(Utilities_1.synUtil.Strings.getValue("guiuploadmultiplefiles"));
            that.m_$wizard.find(".step-propertypage-text").text(Utilities_1.synUtil.Strings.getValue("menuproperty"));
            that.m_$wizard.find(".btn-prev").append(document.createTextNode(Utilities_1.synUtil.Strings.getValue("guinavigatebackward")));
            that.m_$wizard.find(".btn-next").prepend(document.createTextNode(Utilities_1.synUtil.Strings.getValue("guinavigateforward")));
            that.m_$cancelButton
                .off("click").on("click", function () {
                if (Utilities_1.synUtil.Configs.getValue("webconfirmcancel") !== "N") {
                    if (window.confirm(Utilities_1.synUtil.Strings.getValue("confirmcancel")))
                        that.cancelSave();
                }
                else
                    that.cancelSave();
            })
                .text(Utilities_1.synUtil.Strings.getValue("menucancel"));
            that.m_$wizard
                .on("finished.fu.wizard", function (event) {
                if (!that.m_saveInProgress) {
                    $(this).trigger("controlLogFullLicense");
                    let $saveBtn = that.m_$wizard.find(".btn-next");
                    let fileGUIDs = that.m_$uploadContainer.synUpload("getFileGuids");
                    that.m_$propertyPage.synPropertyPage("validate", {
                        ignoreFields: that.m_ignoreFields,
                        validationFailed(errorMsg) {
                            Utilities_1.synUtil.Notifications.error(errorMsg);
                        },
                        validationSuccess() {
                            that.m_saveInProgress = true;
                            Utilities_1.synUtil.beginAjaxProgress($saveBtn);
                            Utilities_1.synUtil.getAJAXData({
                                url: Utilities_1.synUtil.getWSUrl("InstanceCreateMultiple"),
                                method: "PUT",
                                requestData: {
                                    parentId: that.m_parentId,
                                    parentRelId: that.m_relId,
                                    template: JSON.stringify(that.m_$propertyPage.synPropertyPage("getInstance").toJSON()),
                                    changedFields: JSON.stringify(that.m_changedFields),
                                    fileGUIDs: JSON.stringify(fileGUIDs)
                                },
                                done(result) {
                                    let failedGuids = [];
                                    let successGuids = [];
                                    let cntGUID = 0;
                                    for (let fileGUID in result) {
                                        if (result.hasOwnProperty(fileGUID)) {
                                            ++cntGUID;
                                            // Ergebnis des Imports einer einzelnen Date (fileGUID)
                                            let resultItem = result[fileGUID];
                                            if (resultItem.success)
                                                successGuids.push(fileGUID);
                                            else
                                                failedGuids.push({
                                                    fileGUID,
                                                    filename: that.m_$uploadContainer.synUpload("getFileNameFromGuid", fileGUID),
                                                    error: resultItem.error.ErrorDisplayMessage
                                                });
                                        }
                                    }
                                    if (failedGuids.length === 0)
                                        Utilities_1.synUtil.Notifications.success(cntGUID + " " + Utilities_1.synUtil.Strings.getValue("savedmultinew"));
                                    else {
                                        let errorStr = Utilities_1.synUtil.Strings.getValue("guimultidocnew.error") + "<ul>";
                                        _.each(failedGuids, function (item) {
                                            errorStr += "<li>" + item.filename + " (" + item.error + ")</li>";
                                        });
                                        errorStr += "</ul>";
                                        Utilities_1.synUtil.Notifications.warning(errorStr, { autoHideAfter: 10000 });
                                    }
                                    if ($(".staticButtons .mails").data("synMail"))
                                        $(".staticButtons .mails").synMail("attachmentsImported", successGuids);
                                    that.raiseOnViewMadeChanges();
                                    that.m_$uploadContainer.synUpload("clearList", false);
                                    that.disableUI(false);
                                    that.goBack();
                                },
                                cleanUp() {
                                    that.m_saveInProgress = false;
                                    Utilities_1.synUtil.endAjaxProgress($saveBtn);
                                }
                            });
                        }
                    });
                }
            })
                .on('changed.fu.wizard', function (evt, data) {
                that.m_wizardStep = data.step;
                that.m_$wizard.find(".btn-next").contents().filter(function () { return this.nodeType === 3; }).remove();
                if (data.step === 2) {
                    // last step
                    that.updatePropertyPage(that.m_typeId);
                    that.m_$wizard.find(".btn-next").prepend(document.createTextNode(Utilities_1.synUtil.Strings.getValue("menusave")));
                }
                else
                    that.m_$wizard.find(".btn-next").prepend(document.createTextNode(Utilities_1.synUtil.Strings.getValue("guinavigateforward")));
                that.phoneFix();
            })
                .wizard();
            that.phoneFix();
            that.enableNextWizardStep(importFiles.length > 0);
            that.disableUI();
        });
    }
    disableUI(disable = true) {
        super.disableUI(disable);
        if (disable)
            $(".changeBar > .btn").hide();
        else
            $(".changeBar > .btn").show();
    }
    //#endregion Inherited from SynView
    //#region Helpers
    // Layout fix for phone
    phoneFix() {
        let that = this;
        if ("phone" === that.m_clientDeviceClass) {
            that.m_$wizardContainer.css("padding", "0");
            that.m_$categoryChooser.css({
                "display": "block",
                "height": "46px",
                "float": ""
            });
            that.m_$wizard.css({
                "border": "none",
                "box-shadow": "none"
            });
            that.m_$wizard.children(".steps").css({
                "display": "block",
                "height": "35px",
                "margin-left": "0",
                "transform": "scale(0.75, 0.75)",
                "transform-origin": "0% 0%"
            });
            that.m_$wizard.children(".actions").css({
                "border": "none",
                "padding": "0px",
                "width": "100%",
                "display": "block",
                "float": ""
            });
            that.m_$wizard.children(".actions").children(".btn").css({
                "width": "30%",
                "padding": "6px 0px"
            });
            that.m_$wizard.children(".step-content").css({
                "display": "block",
                "float": "none",
                "margin-top": "55px"
            });
        }
    }
    getAllCategories() {
        let d = $.Deferred();
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("GetAllCategories"),
            done(data) {
                d.resolve(data);
            }
        });
        return d.promise();
    }
    getMappingTable(tablename) {
        let d = $.Deferred();
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("MappingTable") + tablename,
            done(dropFilesMap) {
                d.resolve(dropFilesMap);
            },
            fail() {
                d.resolve([]);
            }
        });
        return d.promise();
    }
    cancelSave() {
        if ($(".staticButtons .mails").data("synMail"))
            $(".staticButtons .mails").synMail("attachmentsImportCancelled");
        this.disableUI(false);
        this.goBack();
    }
    buildCategoryHierarchy(typeId, categoryHierarchy) {
        let iTypeId = parseInt(typeId, 10);
        let category = _.findWhere(this.m_allCategories, { id: iTypeId });
        categoryHierarchy.push(iTypeId);
        if (typeof category === "undefined" || category.parentId === 1 && category.id === 1) {
            categoryHierarchy.push(0);
            return categoryHierarchy;
        }
        return this.buildCategoryHierarchy(category.parentId, categoryHierarchy);
    }
    updatePropertyPage(catId) {
        this.m_$propertyPage.synPropertyPage("setTemplate", {
            mode: Base_1.PropertyPageMode.New,
            typeId: parseInt(catId, 10),
            parentId: this.m_parentId,
            parentRelId: this.m_relId
        });
    }
    enableNextWizardStep(enable) {
        this.m_$wizard.find(".btn-next").attr("disabled");
    }
}
exports.newDocMulti = newDocMulti;
